// public/js/components/dropdown.js

export default function Dropdown(rootEl) {
  const toggle = rootEl.querySelector('[data-action="toggle"]');
  const menu = rootEl.querySelector('[data-ref="menu"]');

  if (!toggle || !menu) {
    console.warn('Dropdown: Missing required DOM elements', rootEl);
    return;
  }

  const menuId = menu.id || `dropdown-${Math.random().toString(36).substring(2, 11)}`;
  menu.id = menuId;
  toggle.setAttribute('aria-controls', menuId);
  toggle.setAttribute('aria-haspopup', 'true');

  let isOpen = false;

  const close = () => {
    menu.classList.add('hidden');
    toggle.setAttribute('aria-expanded', 'false');
    isOpen = false;

    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('keydown', handleEscapeKey);
    document.removeEventListener('scroll', handleScroll, true);
  };

  const open = () => {
    document.dispatchEvent(new CustomEvent('close-all-menus'));
    menu.classList.remove('hidden');
    toggle.setAttribute('aria-expanded', 'true');
    isOpen = true;

    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleEscapeKey);
    document.addEventListener('scroll', handleScroll, { capture: true, passive: true });
  };

  const handleOutsideClick = (e) => {
    if (!rootEl.contains(e.target)) {
      close();
    }
  };

  const handleEscapeKey = (e) => {
    if (e.key === 'Escape') {
      close();
      toggle.focus();
    }
  };

  const handleScroll = (e) => {
    // Dismiss dropdown if the scroll event target is outside the dropdown tree itself
    if (!menu.contains(e.target) && isOpen) {
      close();
    }
  };

  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    if (isOpen) close();
    else open();
  });

  document.addEventListener('close-all-menus', () => {
    if (isOpen) close();
  });
}